module.exports = __webpack_public_path__ + "img/gift.a0be92fc.png";